module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/particular02-96162421ce1f06e9eeefdbce95a938c2.png";